<script>
  import { layoutMethods} from "@/state/helpers";
  import peddlrWallet from "@/views/pages/_version_2_/peddlr-lite/merchant/profileInformation/wallet/peddlrWallet";
  import eLoad from "@/views/pages/_version_2_/peddlr-lite/merchant/profileInformation/wallet/eLoad";

  /**
   * Profile Information Wallet component
   */
  export default {
    page: {
      title: "Profile Information Wallet"
    },
    components: {
      peddlrWallet,
      eLoad
    },
    computed: {
    },
    data() {
      return {
        title     : "Profile Information Wallet",
        businessId: 0,
        infoType  : null,
        walletType: null,
        currentView: "peddlrWallet"
      };
    },
    methods: {
      ...layoutMethods,
    },
    async mounted(){
      this.businessId = this.$route.params.bid
      this.infoType = this.$route.params.tab;
      this.walletType = this.$route.params.wallet;
      switch (this.walletType) {
        case "e-load":
          this.title = 'Digital Product Transaction';
          this.currentView = "eLoad";
          break;
        case "peddlr-wallet":
          this.title = 'Kankolek Transaction';
          this.currentView = "peddlrWallet";
          break;
        default:
          break;
      }
      this.changeTitle({title: this.title});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'Merchant List', to: { name: 'Merchant Lite'} },
          { text: 'Account Profile', to: { name: 'Lite Profile Information', params: { tab: this.infoType, bid: this.businessId}} },
          { text: this.title, to: { name: 'Lite Profile Information Wallet', params: { tab: this.infoType, bid: this.businessId, wallet: this.walletType}} }
        ]
      });
      
    }
  }
    
</script>


<template>
  <div class="row"><!-- outer div-->
    <component v-bind:is="currentView"></component>
  </div> <!-- end of outer div-->
</template>


<style>
</style>